import * as t from 'io-ts';

import {parseAnswerFolder, RAnswerFolder} from './answerFolderModel';
import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RAnswerFoldersDirty = t.readonly(
  t.type({
    cannedAnswerFolders: t.array(RAnswerFolder),
  }),
  'answerFolders',
);

/*
 * Type.
 */

export interface AnswerFoldersModel extends t.TypeOf<typeof RAnswerFoldersDirty> {}
export const RAnswerFolders = t.clean<AnswerFoldersModel>(RAnswerFoldersDirty as any);

/*
 * IO methods.
 */

export function parseAnswerFolders(src: any): AnswerFoldersModel {
  return {
    cannedAnswerFolders: src.canned_answer_folders.map(parseAnswerFolder),
  };
}

/*
 * API type.
 */

export const ApiAnswerFolders = makeApiType('answerFolders', RAnswerFolders, parseAnswerFolders);
